import { gql } from "@apollo/client";


const GET_SETTINGS = gql(`query Query($getSettingsId: ID!) {
  getSettings(id: $getSettingsId)
}`);

export { GET_SETTINGS };